.wrapper {
    display: inline-flex;
    align-items: center;
    gap: var(--tempest-space-2);
    cursor: pointer;
    user-select: none;
}

.wrapper.disabled {
    cursor: not-allowed;
    opacity: 0.55;
}

.input {
    position: absolute;
    opacity: 0;
    width: 1px;
    height: 1px;
    pointer-events: none;
}

.track {
    width: 36px;
    height: 20px;
    background-color: var(--tempest-border-strong);
    border-radius: var(--tempest-radius-full);
    position: relative;
    flex-shrink: 0;
    box-shadow: var(--tempest-shadow-inner);
    transition: background-color var(--tempest-duration-base) var(--tempest-ease-out);
}

.thumb {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 16px;
    height: 16px;
    background-color: #ffffff;
    border-radius: 50%;
    box-shadow: var(--tempest-shadow-sm);
    transition: transform var(--tempest-duration-base) var(--tempest-ease-emphasized);
}

.wrapper:hover:not(.disabled) .input:not(:checked) + .track {
    background-color: var(--tempest-gray-400);
}

.input:checked + .track {
    background-color: var(--tempest-primary);
}

.input:checked + .track .thumb {
    transform: translateX(16px);
}

.input:focus-visible + .track {
    outline: var(--tempest-focus-ring-width) solid var(--tempest-focus-ring-color);
    outline-offset: var(--tempest-focus-ring-offset);
}

.label {
    font-size: var(--tempest-text-base);
    color: var(--tempest-text);
}
